export default {
  setCampusList({ commit }, item) {
    commit("SET_CAMPUS_LIST", item);
  },
  setCampusRentAreas({ commit }, item) {
    commit("SET_CAMPUS_RENT_AREAS", item);
  },
   
};
